import React from "react";
import IconLuz from "../componentsStyled/icon/iconluz";
import IconSharp from "../componentsStyled/icon/iconsharp";
import IconDefect from "../componentsStyled/icon/icondefect";
import { Box } from "@mui/material";

const TipoFotos: React.FC = () => {
  return (
    <Box display={"flex"} flexDirection={{ xs: "column", md: "row" }} alignItems={"center"} gap={2}>
      <Box
        display={"flex"}
        flexDirection={{ xs: "row", md: "column" }}
        alignItems={"center"}
        border={"1px solid #ccc"}
        gap={2}
        borderRadius={3}
        padding={3}
        width={{ xs: "80%", md: 220 }}>
        <IconLuz width={40} />
        <p>Certifique-se de estar em um ambiente bem iluminado</p>
      </Box>

      <Box
        display={"flex"}
        flexDirection={{ xs: "row", md: "column" }}
        alignItems={"center"}
        border={"1px solid #ccc"}
        gap={2}
        borderRadius={3}
        padding={3}
        width={{ xs: "80%", md: 220 }}>
        <IconSharp width={40} />
        <p>Faça somente o upload de fotos nítidas.</p>
      </Box>

      <Box
        display={"flex"}
        flexDirection={{ xs: "row", md: "column" }}
        alignItems={"center"}
        border={"1px solid #ccc"}
        gap={2}
        borderRadius={3}
        padding={3}
        width={{ xs: "80%", md: 220 }}>
        <IconDefect width={40} />
        <p>Reserve ao menos uma foto para mostrar defeito, caso possua.</p>
      </Box>
    </Box>
  );
};
export default TipoFotos;
